<template>
    <l-layout :layout="['xs12']">
      <l-data-table
        ref="reservationList"
        class="my-5"
        flat
        :headers="reservationHeaders"
        :get-data-func="getReservations"
        :init-pagination="{sortBy: 'creationTime', descending: true}"
        auto-actions
        clickable
        :filter-items="filter"
        no-data-text="没有预约历史"
        hide-title-search
        @click:row="goReservation($event.item)"
      >
        <template slot="title">
          <v-subheader class="px-0 pr-4">预约历史</v-subheader>
        </template>
      </l-data-table>
      <l-data-table
        ref="personalConfigList"
        :headers="configHeader"
        :get-data-func="(configType==='vehicle')?getReservationConfigList:getPersonReservationConfigList"
        @click:row="(configType==='vehicle')?getConfigDetails($event.item):getPersonConfigDetails($event.item)"
        clickable
        flat
        hide-title-search
        selectable
        v-model="selected"
        :title-text="'个人配置列表'">
        <template slot="title">
          <span class="pl-2 pr-4">个人预约配置列表</span>
          <v-radio-group mandatory row v-model="configType">
            <v-radio :value="'vehicle'" label="车行配置"></v-radio>
            <v-radio :value="'person'" label="人行配置"></v-radio>
          </v-radio-group>
          <v-spacer></v-spacer>
        </template>
        <template slot="title-action">
          <v-btn icon @click="(configType==='vehicle')?addPersonalConfig():addPersonPersonalConfig()">
            <v-icon>$vuetify.icons.add</v-icon>
          </v-btn>
          <v-menu left>
            <v-btn
              icon
              slot="activator"
            >
              <v-icon>$vuetify.icons.more</v-icon>
            </v-btn>
            <v-list dense>
              <v-list-tile
                @click="goFinalReservationConfig('order_letter')"
              >
                <v-list-tile-title class="pr-1">
                  <v-flex layout align-center>
                    <span>查看函件预约最终配置</span>
                  </v-flex>
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                @click="goFinalReservationConfig('order_object')"
              >
                <v-list-tile-title class="pr-1">
                  <v-flex layout align-center>
                    <span>查看个人预约最终配置</span>
                  </v-flex>
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                @click="goFinalReservationConfig('order_group')"
              >
                <v-list-tile-title class="pr-1">
                  <v-flex layout align-center>
                    <span>查看单位预约最终配置</span>
                  </v-flex>
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </template>
      </l-data-table>
      <l-data-table
        ref="configList"
        flat
        :headers="registerHeader"
        hide-title-search
        :title-text="'个人车辆登记配置'"
        :get-data-func="getRegisterConfigList"
        @click:row="goRegisterDetails('readonly',$event.item)"
        clickable
        selectable>
        <template slot="title-action">
          <v-btn icon @click="addRegisterConfig()">
            <v-icon>$vuetify.icons.add</v-icon>
          </v-btn>
        </template>
      </l-data-table>
      <l-data-table
      :headers="vehicleHeader"
      :get-data-func="getVehicleList"
      title-text="个人车辆列表"
      flat
      hide-title-search>
        <template slot="row-action" slot-scope="{item}">
          <td @click.stop class="px-0 mx-0 text-xs-center">
            <v-btn @click="goRules(item)" icon >
              <v-icon small>$vuetify.icons.code</v-icon>
            </v-btn>
          </td>
        </template>
      </l-data-table>
    </l-layout>
</template>

<script>
  import {time} from '../../../../ladmin/utils/time'
  import {Reservation, VIOLATION_STATUS_TEXT} from '../../../../object'
  import LDataTable from "../../../../ladmin/components/LDataTable/LDataTable";
  let typeName = {
    person: '个人预约',
    admin: '高级预约',
    org: '单位预约',
    letter_business: '商业函件预约',
    letter_work: '工作函件预约',
    letter_append: '函件预约追加',
    letter_append_self: '函件预约自助登记'
  }
    export default {
        name: "userExtraConfig",
      components: {LDataTable},
      data(){
        return {
          reservationHeaders: [
            {text: '来访人', value: 'visitorName', align: 'left', placeholder: 'N/A', sortable: false},
            {text: '联系人', value: 'ownerName', align: 'right', placeholder: 'N/A', sortable: false},
            {text: '申请人', value: 'applicantName', align: 'right', placeholder: 'N/A', sortable: false},
            {text: '预约类型', value: 'type', align: 'right', placeholder: 'N/A', sortable: false, f: (v) => (typeName[v])},
            {text: '开始时间', value: 'startDatetime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
            {text: '结束时间', value: 'endDatetime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
            {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
            {text: '是否有效', value: 'status', align: 'left', placeholder: 'N/A', f: (v) => (v === '1' ? '有效' : '失效')},
          ],
          configHeader: [
            {text: '用户名称', value: 'name', align: 'left', sortable: false},
            {text: '用户账号', value: 'loginId', align: 'left', sortable: false},
            {text: '创建时间', value: 'creationTime', align: 'left', f: (v) => time.stringify(v)},
          ],
          registerHeader: [
            {text: '用户名称', value: 'name', align: 'left', sortable: false},
            {text: '用户账号', value: 'loginId', align: 'left', sortable: false},
            {text: '最大可登记数', value: 'maxAllowed', align: 'left', sortable: true},
            {text: '创建时间', value: 'creationTime', placeholder: 'N/A', f: (v) => time.stringify(v)},
            {text: '', value: ''}
          ],
          vehicleHeader:[
            {text: '车辆号牌', value: 'plateNumber', align: 'left', sortable: false},
            {text: '车主姓名', value: 'name', align: 'left', sortable: false},
            {text: '联系方式', value: 'phone', align: 'left', sortable: false},
            {text: '提交时间', value: 'creationTime', align: 'left', f: (v) => time.stringify(v)},
            {text: '', value: ''}
          ],
          configType:'vehicle',
          filter: [
            {
              prependIcon: '$vuetify.icons.edit',
              key: 'status',
              value: '{"r_h_status":"1"}',
              label: '是否有效',
              type: 'select',
              layout: ['xs12', 'sm4'],
              items: [
                {
                  value: '',
                  text: '全部'
                },
                {
                  value: '{"r_h_status":"1"}',
                  text: '有效'
                },
                {
                  value: '{"r_h_status":"-1"}',
                  text: '失效'
                }],
            },
            {
              label: '开始时间',
              layout: 'xs12, sm4',
              type: 'duration',
              key: 'startDatetime',
              value: {},
              range: true,
              f: v => {
                if (!v.startDatetime && !v.endDatetime) {
                  return null
                }
                else {
                  let s = time.toTimeStamp(v.startDatetime) || 0
                  let e = time.toTimeStamp(v.endDatetime) || 9999999999999
                  return [s, e]
                }
              }
            },
            {
              label: '截止时间',
              layout: 'xs12, sm4',
              type: 'duration',
              key: 'endDatetime',
              value: {},
              range: true,
              f: v => {
                if (!v.startDatetime && !v.endDatetime) {
                  return null
                }
                else {
                  let s = time.toTimeStamp(v.startDatetime) || 0
                  let e = time.toTimeStamp(v.endDatetime) || 9999999999999
                  return [s, e]
                }
              }
            }],
          showExtend: false,
          selected:[]
        }
      },
      methods:{
        getReservations ({pagination, sortStack, filterItems}) {
          return this.$store.dispatch('reservation/getReservations', {
            pagination: {page: 1, rowsPerPage: 5},
            sortStack,
            filter: filterItems,
            locate: this.showReservationHistory ? 'history' : 'runtime',
            search: {
              key: 'ownerId', value: this.$route.query.loginId,
            }
          })
        },
        async goReservation (item) {
          console.log(item)
          const map = {
            [Reservation.PERSONAL]: 'PersonalReservationDetails',
            [Reservation.ORG]: 'OrgReservationDetails',
            [Reservation.ADMIN]: 'AdminReservationDetails',
          }
          let routeName = map[item.type]
          if (routeName) {
            this.$router.push({
              name: routeName,
              params: {
                plate: item.plate
              },
              query: {id: item.id}
            })
          }
          else {
            let res = await this.$store.dispatch('reservation/getReservationObgrp', {ownerId: item.ownerId})
            console.log(res)
            let extend = JSON.parse(res.items[0].obgrp.extend)
            this.$router.push({
              name: 'reservationDetails',
              query: {id: extend.procInstId, status: 'read', obGrpName: ''}})
          }
        },
        async getReservationConfigList ({pagination, sortStack, filterItems, search}) {
          let filter = [
            {key:'orderType',value:'order_object'},
            {key:'ownerType',value:'object'},
            {key:'ownerId',value:this.$route.query.id}
          ]
          let {items,amount} = await this.$store.dispatch('reservationConfig/getReservationConfigList', {pagination, filter:filter})
          console.log(items)
          let arr = []
          for (let i = 0; i < items.length; i++) {
            var obj = items[i]
            obj.name = obj.user.name
            obj.loginId = obj.user.loginId
            obj.creationTime = obj.vehicle.creationTime
            obj.id = obj.user.id
            arr.push(obj)
          }
          return {items: arr, amount: amount}
        },
        getConfigDetails (item) {
          // console.log(item)
          let selectionString = document.getSelection().toString()
          if (!selectionString) {
            this.$router.push({
              name: 'ConfigDetail',
              query: {
                ownerId: item.user.id,
                orderType: "order_object",
                status: 'readonly',
                ownerType: 'object'
              }
            })
          }
        },
        goFinalReservationConfig(type){
          if(this.configType==='vehicle'){
            this.$router.push({
              name: 'ConfigDetail',
              query: {
                ownerId: this.$route.query.id,
                orderType: "order_object",
                status: 'readonly',
                ownerType: 'object',
                aim:'final',
                configType:type
              }
            })
          }else{
            this.$router.push({
              name: 'PersonConfigDetail',
              query: {
                ownerId: this.$route.query.id,
                orderType: "order_object",
                status: 'readonly',
                ownerType: 'object',
                aim:'final',
                configType:type
              }
            })
          }
        },
        addPersonalConfig () {
          this.$router.push({
            name: 'NewPersonalConfig',
            query: {
              ownerId: 'newPersonalConfig',
              orderType: "order_object",
              status: 'new',
              ownerType: 'object',
              userId:this.$route.query.id
            }
          })
        },
        async getPersonReservationConfigList ({pagination, sortStack, filterItems, search}) {
          let filter = [
            {key:'orderType',value:'order_object'},
            {key:'ownerType',value:'object'},
            {key:'ownerId',value:this.$route.query.id}
          ]
          let {items,amount} = await this.$store.dispatch('personReservationConfig/getReservationConfigList', {pagination, filter:filter})
          console.log(items)
          let arr = []
          for (let i = 0; i < items.length; i++) {
            var obj = items[i]
            obj.name = obj.user.name
            obj.loginId = obj.user.loginId
            obj.creationTime = obj.vehicle.creationTime
            obj.id = obj.user.id
            arr.push(obj)
          }
          return {items: arr, amount: amount}
        },
        getPersonConfigDetails (item) {
          // console.log(item)
          let selectionString = document.getSelection().toString()
          if (!selectionString) {
            this.$router.push({
              name: 'PersonConfigDetail',
              query: {
                ownerId: item.user.id,
                orderType: "order_object",
                status: 'readonly',
                ownerType: 'object'
              }
            })
          }
        },
        async getRegisterConfigList ({pagination, sortStack, filterItems = [], search}) {
          let filter = [
            {key:'ownerType',value:'object'},
            {key:'ownerId',value:this.$route.query.id},
          ]
          let {items,amount} = await this.$store.dispatch('vehicleRegister/getRegisterConfigList', {pagination, filter:filter})
          console.log(items)
          let arr = []
          //console.log(res)
          for (let i = 0; i <items.length; i++) {
            let item = items[i]
            var obj = {
              creationTime: item.config.creationTime,
              maxAllowed: item.config.maxAllowed,
              name: item.user.name,
              loginId: item.user.loginId ,
              item: item
            }
            arr.push(obj)
          }
          return {items: arr, amount:amount}
        },
        addPersonPersonalConfig () {
          this.$router.push({
            name: 'PersonNewPersonalConfig',
            query: {
              ownerId: 'newPersonalConfig',
              orderType: "order_object",
              status: 'new',
              ownerType: 'object',
              userId:this.$route.query.id
            }
          })
        },
        addRegisterConfig () {
          this.$router.push({
            name: 'newCommonConfig',
            query: {
              ownerId: '',
              status: 'new',
              ownerType: 'object',
              userId:this.$route.query.id
            }
          })
        },
        goRegisterDetails (status, item) {
          //console.log(item)
          let selectionString = document.getSelection().toString()
          if (!selectionString) {
            this.$router.push({
              name: 'commonConfig',
              query: {
                ownerId: (this.ownerType === 'group') ? item.item.group.id : item.item.user.id,
                status: status,
                ownerType: this.ownerType,
              }
            })
          }
        },
        async getVehicleList ({pagination, sortStack, filterItems, search}) {
          let filter = [
            {key:"userId",value:this.$route.query.id},
            {key:'status',value:"1"}
          ]
          let {items,amount} = await this.$store.dispatch('passControl/getSelfVehicleList', {pagination,filter:filter})
          let arr = []
          for(let i=0;i<items.length;i++){
            let item = items[i]
            item.plateNumber = item.vehicle.plateNumber
            item.name = item.user.name
            item.phone = item.user.mobilePhone
            item.creationTime = item.vehicle.creationTime
            arr.push(item)
          }
          return {items: arr, amount: amount}
        },
        goRules(item){
          this.$router.push({
            name:'vehicleRuleDetailsBox',
            query:{
              id:item.plateNumber
            }
          })
        }
      }
    }
</script>

<style scoped>

</style>
